module.exports = __webpack_public_path__ + "static/img/icon02.8007834d.png";